module.exports = __webpack_public_path__ + "static/media/3DPPA22.1ff86db3.jpg";